/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropplacehint2Inputs */

const en_dropplacehint2 = /** @type {(inputs: Dropplacehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The voucher is redeemed here.`)
};

const de_dropplacehint2 = /** @type {(inputs: Dropplacehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier wird der Gutschein eingelöst.`)
};

/**
* | output |
* | --- |
* | "The voucher is redeemed here." |
*
* @param {Dropplacehint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropplacehint2 = /** @type {((inputs?: Dropplacehint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropplacehint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropplacehint2(inputs)
	return de_dropplacehint2(inputs)
});
export { dropplacehint2 as "dropPlaceHint" }